import React from 'react';

import {
  Paper,
  Typography,
  Grid,
  Button,
} from '@material-ui/core';

import AccountIcon from '@material-ui/icons/AccountCircle';

import classes from '../../css/getCSS';

const basicInfo = (props) => {
  let editButton = null;

  if (props.profile.is_editable) {
    editButton = (
      <Button size="small" className={classes.profileEditButton} variant="outlined" onClick={() => props.editProfileSection('basicinfo')}>Edit</Button>
    );
  }

  return (
    <React.Fragment>
      <Paper className={[classes.card, classes.cardFancy, classes.noBorderXS].join(' ')}>
        {editButton}
        <Typography variant="subheading" className={classes.profileSectionTitle}>
          <AccountIcon className={classes.titleIcon} />
          Basic Information
        </Typography>
        <br />
        <Grid container>

          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>First Name</p>
            <p className={classes.profileVal}>{props.profile.basicinfo.first_name}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Last Name</p>
            <p className={classes.profileVal}>{props.profile.basicinfo.last_name}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Communication Email</p>
            <p className={classes.profileVal}>{props.profile.basicinfo.email}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Phone No.</p>
            <p className={classes.profileVal}>+{props.profile.basicinfo.country_code.country_code} {props.profile.basicinfo.phone}</p>
            <br />
          </Grid>
          <Grid item md={6} sm={6} xs={12}>
            <p className={classes.profileCap}>Lohana Connect ID</p>
            <p className={classes.profileVal}>{props.profile.basicinfo.lohana_connect_id?props.profile.basicinfo.lohana_connect_id:'-'}</p>
            <br />
          </Grid>
        </Grid>
      </Paper>
    </React.Fragment>
  );
};


export default basicInfo;



// WEBPACK FOOTER //
// ./src/profile/components/BasicInfo.js